import React from 'react';

const ConstructionBanner = () => {
  return (
    <div className="construction-banner">
      <p>This web app is currently under reconstruction and resources are set to 0.</p>
      <p>If you need to get in touch, <a href="mailto:info@sceneextractor.com">contact us via email</a> or fill out the forms.</p>
    </div>
  );
};

export default ConstructionBanner;
